import * as tslib_1 from "tslib";
import * as pathToRegexp from 'path-to-regexp';
import { Component, Vue, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    constructor() {
        super(...arguments);
        this.breadcrumbs = [];
        this.currentPath = '';
    }
    created() {
        this.getBreadcrumb();
    }
    onRouteChange(route) {
        // if you go to the redirect page, do not update the breadcrumbs
        if (route.path.startsWith('/redirect/')) {
            return;
        }
        this.getBreadcrumb();
    }
    getBreadcrumb() {
        this.currentPath = this.$route.path;
        const matched = this.$route.matched.filter((item) => item.meta && item.meta.title);
        if (!this.isHome(matched[0])) {
            const home = {
                name: 'Home',
                path: '/',
                meta: { title: '首页' },
            };
            matched.unshift(home);
        }
        this.breadcrumbs = matched;
    }
    isHome(route) {
        const name = route && route.name;
        if (!name) {
            return false;
        }
        return name.trim().toLowerCase() === 'Home'.toLowerCase();
    }
    compilePath(path) {
        const { params } = this.$route;
        const compiler = pathToRegexp.compile(path);
        return compiler(params);
    }
    handleLink(route) {
        const { redirect, path } = route;
        if (redirect) {
            this.$router.push(redirect);
            return;
        }
        this.$router.push(this.compilePath(path));
    }
};
tslib_1.__decorate([
    Watch('$route')
], default_1.prototype, "onRouteChange", null);
default_1 = tslib_1.__decorate([
    Component({
        name: 'Breadcrumb',
    })
], default_1);
export default default_1;
